'use strict';

import tinymce from 'tinymce/tinymce.min';

import 'tinymce/themes/silver';

import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/link'
import 'tinymce/plugins/image'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/imagetools'

const uploadedImg = [];

const defaultHandler = function uploadImages(blobInfo, success, failure) {
    let reader = new FileReader();

    reader.onload = function (e) {
        let base64img = e.target.result;
        if (base64img) {
            uploadedImg.push(base64img);
            success(base64img);
        }
    };

    reader.onerror = function(e) {
        failure(e);
    };

    reader.readAsDataURL(blobInfo.blob());
};


const myTinyMDC = {
    /**
     * Tiny MDC init
     *
     * @param {ConstrainDOMString} selector
     * @param {function} handler
     */
    init: function (selector, handler) {
        tinymce.init({
            selector: selector,
            plugins: 'image, imagetools, wordcount, link, paste',
            toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image paste',
            images_upload_handler: handler || defaultHandler,
            height: '65vh',
            relative_urls: false,
            remove_script_host: false,
            convert_urls: true,
        });
    },
    getUploadedPictures: function () {
        return uploadedImg;
    },
    getContent: function () {
        return tinymce.activeEditor.getContent()
    }
};

export default myTinyMDC;